module.exports = __webpack_public_path__ + "static/image/service/m/shopping_live@3x.jpg?bce45787";